import { WIDTH, HEIGHT } from './AnnotationDescPanel.constants';

export const isCompleteVisibleH = (left, wrapperRef) => (
  wrapperRef.current && left && (left < (wrapperRef.current.offsetWidth - WIDTH))
);

export const isCompleteVisibleV = (top, wrapperRef) => (
  wrapperRef.current && top && (top < (wrapperRef.current.offsetHeight - HEIGHT))
);
